import { render, staticRenderFns } from "./ExaminationRecords.vue?vue&type=template&id=04ac3d72&scoped=true&"
import script from "./ExaminationRecords.vue?vue&type=script&lang=js&"
export * from "./ExaminationRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ac3d72",
  null
  
)

export default component.exports